module.exports = __webpack_public_path__ + "img/icon_nud.f303708e.svg";